import { Component, ChangeDetectionStrategy } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { UrlParamsService } from 'src/app/shared/services/url-params.service';
import { SubscriptionService } from '../../subscription.service';
import { MinProjectDTO } from '../../types/MinProjectDTO';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-confirm-subscription',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './confirm-subscription.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './confirm-subscription.component.scss',
})
export class ConfirmSubscriptionComponent {
  projectGuid: string | null = null;
  stakeGuid: string | null = null;
  projectInfo: MinProjectDTO | null = null;
  private subscription: Subscription | null = null;

  constructor(
    private urlParamsService: UrlParamsService,
    private subscriptionService: SubscriptionService
  ) {
    this.projectGuid = this.urlParamsService.projectGuid;
    this.stakeGuid = this.urlParamsService.stakeGuid;
  }

  ngOnInit(): void {
    this.subscription = this.subscriptionService.projectInfo$.subscribe({
      next: (projectInfo) => {
        this.projectInfo = projectInfo;
      },
      error: (error) => {
        console.error('Error fetching project info:', error);
      },
    });
  }

  startOver(): void {
    this.urlParamsService.navigateWithParams('/subscription/search');
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
